import {
  loadCalendarEvents,
  createCalendarEvent,
  updateCalendarEvent,
  deleteCalendarEvent
} from '../services/calendarApi';

/**
 * 日付クリック処理を生成
 */
export const createDateClickHandler = (calendarState) => {
  return (arg) => {
    calendarState.setDefaultEvent(arg.dateStr);
    calendarState.setOpen(true);
  };
};

/**
 * イベントクリック処理を生成
 */
export const createEventClickHandler = (calendarState) => {
  return async (info) => {
    try {
      const loadedEvents = await loadCalendarEvents();
      const clickedEvent = loadedEvents.find(event => event.id === info.event.id);
  
      if (clickedEvent) {
        calendarState.setTempEvent({
          id: clickedEvent.id,
          title: clickedEvent.title || '',
          notes: clickedEvent.notes || '',
          start: clickedEvent.start || '',
          end: clickedEvent.end || clickedEvent.start,
          category: clickedEvent.category || '社会',
          person: clickedEvent.person || '',
          area: clickedEvent.area || '本社'
        });
        calendarState.setOpen(true);
      }
    } catch (error) {
      console.error('スケジュール情報の取得エラー:', error);
    }
  };
};

/**
 * ドラッグ&ドロップ処理を生成
 */
export const createEventDropHandler = (calendarEvents) => {
  return async (info) => {
    try {
      const loadedEvents = await loadCalendarEvents();
      const droppedEvent = loadedEvents.find(event => event.id === info.event.id);

      if (droppedEvent) {
        const newStartDate = new Date(info.event.start);
        newStartDate.setDate(newStartDate.getDate() + 1);

        const startDate = new Date(droppedEvent.start);
        const endDate = new Date(droppedEvent.end);
        const dayDifference = Math.round((endDate - startDate) / (1000 * 60 * 60 * 24));

        const newEndDate = new Date(newStartDate);
        newEndDate.setDate(newStartDate.getDate() + dayDifference);

        const updatedEvent = {
          ...droppedEvent,
          start: newStartDate.toISOString().split('T')[0],
          end: newEndDate.toISOString().split('T')[0]
        };

        const updatedEvents = loadedEvents.map(event =>
          event.id === updatedEvent.id ? updatedEvent : event
        );
        calendarEvents.setEvents(updatedEvents);

        await updateCalendarEvent(updatedEvent.id, updatedEvent);
      }
    } catch (error) {
      console.error('スケジュール移動エラー:', error);
    }
  };
};

/**
 * 削除処理を生成
 */
export const createDeleteHandler = (calendarState, calendarEvents) => {
  return async () => {
    if (calendarState.isSaving || !calendarState.tempEvent.id) return;
    
    if (!window.confirm('このスケジュールを削除してもよろしいですか？')) return;
    
    calendarState.setIsSaving(true);
    
    try {
      const result = await deleteCalendarEvent(String(calendarState.tempEvent.id));
      if (result === false) {
        throw new Error('削除処理に失敗しました');
      }
      
      calendarEvents.setEvents(calendarEvents.events.filter(event => 
        String(event.id) !== String(calendarState.tempEvent.id)
      ));
      calendarState.setOpen(false);
    } catch (error) {
      alert('削除処理に失敗しました');
      console.error('削除エラー:', error);
    } finally {
      calendarState.setIsSaving(false);
    }
  };
};

/**
 * 保存処理を生成
 */
export const createSaveHandler = (calendarState, calendarEvents, currentUser) => {
  return async () => {
    if (calendarState.isSaving) return;
    calendarState.setIsSaving(true);

    try {
      const { tempEvent } = calendarState;
      
      // 入力値検証
      if (new Date(tempEvent.start) > new Date(tempEvent.end)) {
        alert("終了日は開始日より後の日付を選択してください。");
        return;
      }

      if (!tempEvent.start || !tempEvent.end) {
        alert('開始日と終了日は必須です');
        return;
      }

      if (tempEvent.id) {
        // 更新処理
        const updatedEvent = {
          ...tempEvent,
          date: tempEvent.start,
          title: tempEvent.title || '',
          notes: tempEvent.notes || '',
          person: tempEvent.person || '',
          category: tempEvent.category || '社会',
          area: tempEvent.area || '本社',
          updatedBy: currentUser?.userId,
          updatedByUsername: currentUser?.username
        };
        
        await updateCalendarEvent(tempEvent.id, updatedEvent);
        calendarEvents.setEvents(calendarEvents.events.map(event =>
          event.id === tempEvent.id ? updatedEvent : event
        ));
        
      } else {
        // 新規作成処理
        const newEvent = {
          ...tempEvent,
          date: tempEvent.start,
          title: tempEvent.title || '',
          notes: tempEvent.notes || '',
          person: tempEvent.person || '',
          category: tempEvent.category || '社会',
          area: tempEvent.area || '本社',
          createdBy: currentUser?.userId,
          createdByUsername: currentUser?.username
        };
        
        // 重複チェック
        const isDuplicate = calendarEvents.events.some(event =>
          event.title === newEvent.title &&
          event.notes === newEvent.notes &&
          event.person === newEvent.person &&
          event.start === newEvent.start &&
          event.end === newEvent.end &&
          event.category === newEvent.category &&
          event.area === newEvent.area
        );
        
        if (isDuplicate) {
          alert('同じ内容のスケジュールが既に登録されています');
          return;
        }

        const savedEvent = await createCalendarEvent(newEvent);
        calendarEvents.setEvents([...calendarEvents.events, savedEvent]);
      }
      
      calendarState.setOpen(false);
      
    } catch (error) {
      alert('保存に失敗しました');
      console.error('保存エラー:', error);
    } finally {
      calendarState.setIsSaving(false);
    }
  };
};